/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from "react";
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import { KTSVG } from '../../../_metronic/helpers';
import { getRequestOptions } from "../../components/GetToken";
import { GetPagePermission } from "../../components/UserPagePermission";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import userPermissionContext from '../../../context/userPermissionContext';
import BackendTable from 'react-backend-table';
import { formatBdt } from '../../helpers/formatBdt';

/**
 * Workaround for react-select menuPosition="fixed" not working properly.
 * Render the menu in a portal attached to document.body,
 * which ensures the dropdown appears above modals/scroll areas.
 */
const selectMenuPortalTarget = typeof window !== "undefined" ? document.body : null;

function VehicleExpenseReport() {
	const initialState = () => ({
		expenseHeadsData: [],
		expenseDateFrom: "",
		expenseDateTo: "",
	});
	const { jwt, businessUnit } = useContext(userPermissionContext);
	const backendTableRef = useRef(null);
	const [reloadMyTable, setReloadMyTable] = useState(false);
	const [expenseTypeInfo, setExpenseTypeInfo] = useState(initialState());
	const [expenseHeads, setExpenseHeads] = useState([]);
	const hasPermission = GetPagePermission('/report-vehicleExpenseReport');
	const selectHeadRef = useRef();

	let columns = [
		{
			title: 'Vehicle Number', field: 'vehicleNumber', sortable: true, searchable: true,
			// hasComponent: true,
			// componentValue: ((rowValue) => {
			// 	return (
			// 		<Link to={`/vehicleDetails/${rowValue.idVmsVehicleInfo}`} target="_blank" rel="noopener noreferrer">
			// 			{rowValue.vehicleNumber}
			// 		</Link>
			// 	)

			// })
		},
		{ title: 'Vehicle Type', field: 'vehicleType', sortable: true, searchable: true },
		{ title: 'Details', field: 'vehicleDetails', searchable: true, sortable: true },
		{ title: 'Color', field: 'colorName', searchable: true, sortable: true },
		{ title: 'Project', field: 'assignedProject', searchable: true, sortable: true },
		{ title: 'Sub Project', field: 'subProjectName', searchable: true, sortable: true },
		{ title: 'Expense Name', field: 'expenseName', searchable: true, sortable: true },
		{ title: 'Expense Head', field: 'expenseHead', searchable: true, sortable: true },
		{
			title: 'Total Amount',
			field: 'totalExpenseAmount',
			searchable: true,
			sortable: true,
			tdStyle: { textAlign: 'right' },
			hasComponent: true,
			componentValue: (rowValue) => formatBdt(rowValue?.totalExpenseAmount),
		}
	]

	let options = {
		url: process.env.REACT_APP_API_URL + 'generateExpenseDetailsReport?currentProject=' + businessUnit.idProjects,
		authorization: 'Bearer ' + jwt.token,
		perPage: [50, 100, 500, 1000, 'All'],
		orderBy: 'vehicleNumber',
		orderType: 'desc',
		columnSearch: true,
		extraData: expenseTypeInfo
	}

	useEffect(() => {
		backendTableRef.current?.reload();
		setReloadMyTable(false);
	}, [businessUnit, reloadMyTable]);

	useEffect(() => {
		const getExpenseHeads = () => {
			fetch(process.env.REACT_APP_API_URL + "getAllExpenseHeads", getRequestOptions())
				.then((resp) => resp.json())
				.then((resp) => {
					if (resp.status && resp.data) {
						setExpenseHeads(resp.data);
					}
				})
				.catch((error) => console.log(error, "getExpenseHeads catch"));
		};
		getExpenseHeads();
	}, [])

	const handleDataChange = evt => {
		setExpenseTypeInfo({ ...expenseTypeInfo, [evt.target.name]: evt.target.value });
		setReloadMyTable(true);
	}

	const handleExpenseHeadChange = (expenseHead) => {
			setExpenseTypeInfo({
				...expenseTypeInfo,
				expenseHeadsData: expenseHead,
			});
		setReloadMyTable(true);
	}

	return (
		<>
			{hasPermission === 1 &&
				<div className="card card-custom">
					<div className='card-header d-flex flex-direction-row justify-content-between py-4'>
						<div className='card-title w-50'>
							<KTSVG
								path='/media/svg/icons/Shopping/Money.svg'
								className='svg-icon-1 svg-icon-primary'
							/>
							<span className="text fw-bolder" style={{ marginLeft: "10px" }}>
								EXPENSES INFORMATION
							</span>
						</div>
					</div>

					<div className="ml-12">
						<div className="card-body">
							<div className="ml-12">
								<div className="form-group row mt-5">
								<label htmlFor="expenseHead" className="col-lg-1 col-form-label" style={{ "textAlign": "right" }} >Head</label>
									<div className="col-lg-4">
										<Select
											ref={selectHeadRef}
											id="expenseHead"
											value={expenseTypeInfo.expenseHeadsData}
											options={expenseHeads}
											onChange={handleExpenseHeadChange}
											isMulti
											menuPortalTarget={selectMenuPortalTarget}
											styles={{
												menuPortal: base => ({
													...base,
													zIndex: 9999
												}),
											}}
										/>
									</div>
									<label htmlFor="expenseDateFrom" className="col-lg-1 col-form-label" style={{ "textAlign": "right" }} >From</label>
									<div className="col-lg-2">
										<input type="date" name="expenseDateFrom" id="expenseDateFrom" value={expenseTypeInfo.expenseDateFrom} onChange={handleDataChange} placeholder="Select Date From" className="form-control form-control-sm" />
									</div>
									<label htmlFor="expenseDateTo" className="col-lg-1 col-form-label" style={{ "textAlign": "right" }} >To</label>
									<div className="col-lg-2">
										<input type="date" name="expenseDateTo" id="expenseDateTo" value={expenseTypeInfo.expenseDateTo} onChange={handleDataChange} placeholder="Select Date To" className="form-control form-control-sm" />
									</div>
								</div>
							</div>
						</div>

						<div className='ml-12'>
							<div className='' style={{ overflowX: "hidden" }}>
								<BackendTable ref={backendTableRef} columns={columns} options={options} />
							</div>
						</div>
					</div>
				</div>
			}
			{
				hasPermission === 0 &&
				<div className='card card-custom' style={{ padding: "15px" }} >
					<SkeletonTheme>
						<p>
							<Skeleton
								containerClassName="avatar-skeleton"
								count={40} ></Skeleton>
						</p>
					</SkeletonTheme>
				</div>
			}

		</>
	)

}

export default VehicleExpenseReport